// base=/etc/designs/base/clientlibs

// # scs.base.desktop
// # ========================
// # Be careful when adding files here.
// # These files are included in the desktop clientlibs on portal, and possibly others.
// # TODO: Remove this from base, because it is already included in portal/clientlibs/libs
// (and fix dependencies to this client lib)
import 'etc/designs/base/clientlibs/shared/vendor/ba-debug.min.js';

import 'bootstrap/load-moment';

import 'etc/designs/base/clientlibs/shared/vendor/jquery.cookies.2.2.0.min.js';
import '@swisscom/bxslider/dist/jquery.bxslider';
import 'etc/designs/base/clientlibs/shared/vendor/yepnope.1.5.4-min.js';
import 'bootstrap/load-snabbdom';
import 'etc/designs/base/clientlibs/shared/libraries/scCookie.js';
import 'etc/designs/base/clientlibs/shared/libraries/SCS.hashdeeplink.js';

import 'etc/designs/base/clientlibs/shared/js/modules/Tc.Module.BrightcoveVideo.js';
import 'etc/designs/base/clientlibs/shared/js/modules/Tc.Module.GoogleMaps.js';
import 'etc/designs/base/clientlibs/shared/js/modules/Tc.Module.Slider.js';
import 'etc/designs/base/clientlibs/shared/js/modules/Tc.Module.Slider.RotatingTeaser.js';
import 'etc/designs/base/clientlibs/shared/js/modules/Tc.Module.Twitter.js';
import 'etc/designs/base/clientlibs/shared/js/modules/Tc.Module.LinkForwarder.js';

import 'etc/designs/base/clientlibs/shared/libraries/SCS.Url.js';

import 'lib/generic/seo-utils';

// Tealium library
import 'etc/designs/base/clientlibs/shared/libraries/tracking/SCS.portal.datalayer.js';

// Modern modules (using imports/exports)
import IFrame from 'lib/containers/Tc.Module.IFrame';

const modernTcModules = {
	IFrame,
};
// Tc Bootstrap
import { legacyBootstrapDeferredSingleton } from 'bootstrap/load-terrific';
legacyBootstrapDeferredSingleton(modernTcModules);



// WEBPACK FOOTER //
// typescript://../clientlibs/js/by-category/scs.base.desktop.ts